/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IconProps } from '../types';

type IconPropsExtended = IconProps;

export const ListIcon = ({
  className,
  ...otherProps
}: IconPropsExtended): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="ListIcon"
    role="img"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={classNames('cogs-icon', className)}
    {...otherProps}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.059 4a.725.725 0 0 0-1.45 0v.007a.725.725 0 1 0 1.45 0zM6 3.275a.725.725 0 0 0 0 1.45h7.333a.725.725 0 0 0 0-1.45zm0 4a.725.725 0 0 0 0 1.45h7.333a.725.725 0 0 0 0-1.45zM5.275 12c0-.4.325-.725.725-.725h7.333a.725.725 0 0 1 0 1.45H6A.725.725 0 0 1 5.275 12M3.334 7.275c.4 0 .725.325.725.725v.007a.725.725 0 1 1-1.45 0V8c0-.4.324-.725.725-.725M4.059 12a.725.725 0 0 0-1.45 0v.007a.725.725 0 0 0 1.45 0z"
      clipRule="evenodd"
    />
  </svg>
);
